import { useContext } from 'react'

import { WorkforceFormContext } from './workforce-context'

export function useWorkforceForm() {
  const ctx = useContext(WorkforceFormContext)
  if (!ctx) {
    throw new Error(
      'useWorkforceForm must be used within WorkforceFormProvider'
    )
  }
  return ctx
}
